//Standard libraries
import { AxiosPromise } from "axios";
//Foundation libraries
import { getSite } from "../../hooks/useSite";
import { site } from "../../constants/site";
import {
  DemandeRDVApi,
  DemandeSAVApi,
  CreateClaimApi,
  GetTimeSlotsApi,
  ScanAttachmentsApi,
  UploadAttachmentApi,
} from "@hcl-commerce-store-sdk/typescript-axios-transaction";

const demandeRDVApiInstance = new DemandeRDVApi(undefined, site.transactionContext);
const demandeSAVApiInstance = new DemandeSAVApi(undefined, site.transactionContext);
const createClaimApiInstance = new CreateClaimApi(undefined, site.transactionContext);
const scanAttachmentInstance = new ScanAttachmentsApi(undefined, site.transactionContext);
const uploadAttachmentInstance = new UploadAttachmentApi(undefined, site.transactionContext);
const getTimeSlotApiInstance = new GetTimeSlotsApi(undefined, site.transactionContext);
const demandeService = {
  /**
   * Get the RDV detail.
   * @summary Get the RDV detail
   * @param {string} storeId The store identifier.
   * @param {DemandeRDVRequest} demandeRDVRequest The request object for project creation.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  addDemandeRDV(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;
    return demandeRDVApiInstance.demandeRDV(storeId, body, options);
  },

  /**
   * Get the SAV detail.
   * @summary Get the SAV detail
   * @param {string} storeId The store identifier.
   * @param {DemandeSAVRequest} demandeSAVRequest The request object for project creation.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DemandeSAVApi
   */
  addDemandeSAV(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;
    return demandeSAVApiInstance.demandeSAV(storeId, body, options);
  },
  createClaim(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;
    return createClaimApiInstance.createClaim(storeId, body, options);
  },

  scanAttachment(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;
    return scanAttachmentInstance.scanAttachments(storeId, body, options);
  },

  uploadAttachement(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;
    return uploadAttachmentInstance.uploadAttachment(storeId, body, options);
  },

  getTimeSlots(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, storeCode, universe, type, ...options } = parameters;
    return getTimeSlotApiInstance.getTimeSlots(storeId, storeCode, universe, type, options);
  },
};

export default demandeService;
